import { combineReducers, configureStore } from '@reduxjs/toolkit';
import type { Middleware as GenericMiddleware } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { uiReducer } from './UI/reducer';
import { personalizationReducer } from './Personalization/reducer';

const rootReducer = combineReducers({
  personalization: personalizationReducer,
  ui: uiReducer,
});

type RootState = ReturnType<typeof rootReducer>;
type Store = ReturnType<typeof createStore>;

const middleWares: GenericMiddleware[] = [];

export const createStore = (initialState?: RootState) =>
  configureStore({
    devTools: { name: 'gift-editor' },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(middleWares),
    preloadedState: initialState,
    reducer: rootReducer,
  });

export type TypedDispatch = Store['dispatch'];

export const useTypedDispatch = useDispatch.withTypes<Store['dispatch']>();
export const useTypedSelector = useSelector.withTypes<RootState>();

// as Recommended by Redux keep using {} https://redux.js.org/usage/usage-with-typescript#type-checking-middleware
// eslint-disable-next-line @typescript-eslint/ban-types
export type TypedMiddleware = GenericMiddleware<{}, RootState, TypedDispatch>;
export type { RootState, Store };

export const giftEditorStore = createStore();
